import React from 'react';

import { Resources } from '@ragu-components/ord-resources';

import type { OrdResourceProps } from '@ragu-components/ord-resources';
import type { ScimProvisioning } from '@ragu-components/ord-types';

const ScimProvisioningsList = React.lazy(async () => import('./ScimProvisioningsList'));

export const scimProvisioningsResource: OrdResourceProps = {
  key: Resources.scim_provisionings,
  name: Resources.scim_provisionings,
  list: <ScimProvisioningsList />,
  recordRepresentation: (record: ScimProvisioning) => record.id,
  options: {},
};
